'use client';
/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import*as a from"react";import{Root as e}from"../../node_modules/@radix-ui/react-separator/dist/index.js";import{cn as o}from"../../lib/utils.js";const r=a.forwardRef((({className:r,orientation:t="horizontal",decorative:i=!0,...s},l)=>a.createElement(e,{ref:l,decorative:i,orientation:t,className:o("shrink-0 bg-[#58667E]/10","horizontal"===t?"h-[1px] w-full":"h-full w-[1px]",r),...s})));r.displayName=e.displayName;export{r as default};
//# sourceMappingURL=Separator.js.map
